import { INDUSTRY_OPTIONS } from '../IntermediaryFees/types';

export const industryAndRoleQuestions: Record<string, any> = {
  industry: {
    labelKey: 'applicationForm.INDUSTRY_AND_ROLE.industry.label',
    explanationKey: 'applicationForm.INDUSTRY_AND_ROLE.industry.explanation',
    options: INDUSTRY_OPTIONS.map(option => ({ label: option, value: option })),
  },
  role: {
    labelKey: 'applicationForm.INDUSTRY_AND_ROLE.role.label',
  },
};
